import React, { Component } from "react";
import { func, any, string, bool } from "prop-types";
import classnames from "classnames";
import inspectionApi from "../../utils/api/inspection";
import { ProjectContext } from "../../contexts/ProjectContext";
import { noop } from "lodash";
import ReactTooltip from "react-tooltip";
import InspectionTypeSelectionModal from "./InspectionTypeSelectionModal";
import { toast } from 'react-toastify';

class InspectionAdd extends Component {
  static contextType = ProjectContext;
  
  static propTypes = {
    disabled: bool,
    reason: string,
    onInspectionAdd: func,
    className: any,
    type: string.isRequired,
  };

  static defaultProps = {
    className: "outline small",
    onInspectionAdd: noop,
  };

  state = {
    busy: false,
    showModal: false,
  };

  tooltipTimeout = null;

  componentDidMount() {
    // Add click event listener to hide tooltip when clicking anywhere
    document.addEventListener('click', this.handleDocumentClick);
  }

  componentWillUnmount() {
    // Clean up event listener and timeout
    document.removeEventListener('click', this.handleDocumentClick);
    
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout);
    }
  }

  handleDocumentClick = () => {
    // Hide tooltip when clicking anywhere on the screen
    ReactTooltip.hide(this.buttonRef);
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout);
      this.tooltipTimeout = null;
    }
  };

  showTooltipWithTimeout = () => {
    if (this.props.reason) {
      ReactTooltip.show(this.buttonRef);
      
      // Clear any existing timeout
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
      }
      
      // Set timeout to auto-hide after 5 seconds
      this.tooltipTimeout = setTimeout(() => {
        ReactTooltip.hide(this.buttonRef);
      }, 3000);
    }
  };

  handleButtonClick = () => {
    if (this.state.busy || this.props.disabled) {
      return;
    }
    this.setState({ showModal: true });
  };

  handleModalSubmit = (inspectionTypes) => {
    if (this.state.busy) {
      return;
    }

    const { onInspectionAdd, inspectionRefetch, teamManagementRefetch } = this.props;

    this.setState({ 
      busy: true, 
      showModal: false
    });

    // Show progress toast
    const toastId = toast.loading("Inspection creation in progress...", {
      autoClose: false,
      closeButton: false,
      hideProgressBar:false,
    });

    return inspectionApi
      .create(this.context.project.id, inspectionTypes,'Inspection Add component')
      .then(result => {
        this.setState({ busy: false });
        
        // Dismiss progress toast
        toast.dismiss(toastId);
        
        // Show success toast
       
        toast.success(
          `Inspection Created Successfully!`,
          {
            autoClose: 3000,
          }
        );
        
        onInspectionAdd(result);
        inspectionRefetch();
        teamManagementRefetch();
      })
      .catch(err => {
        this.setState({ busy: false });

        // Dismiss progress toast
        toast.dismiss(toastId);
        
        // Show error toast
        toast.error("Failed to create inspection. Please try again.", {
          autoClose: 5000,
        });

        /** @todo global app error handler */
        console.error(err);

        return Promise.reject(err);
      });
  };

  hideModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { className, disabled, reason } = this.props;
    const { busy, showModal } = this.state;

    return (
      <>
        <button
          className={classnames(className, "new-inspection")}
          onClick={!busy && !disabled ? this.handleButtonClick : null}
          ref={ref => (this.buttonRef = ref)}
          data-tip={reason}
          onMouseOver={this.showTooltipWithTimeout}
          disabled={busy || disabled}
        >
          New Inspection
        </button>
        <ReactTooltip
          place="top"
          effect="solid"
          getContent={() => reason}
        />
        <InspectionTypeSelectionModal
          show={showModal}
          hideModal={this.hideModal}
          onSubmit={this.handleModalSubmit}
        />
      </>
    );
  }
}

export default InspectionAdd;